import {
  PRESCREENER_CATEGORIES,
  PRESCREENER_CATEGORY_KEYS,
} from 'client-portal/utils/prescreener/constants';

export const CLIENT_TYPE_STEP_ID = 'client-type';

const OPTIONAL_CATEGORY_ORDER = [
  PRESCREENER_CATEGORIES.REASON_FOR_CARE,
  PRESCREENER_CATEGORIES.ADMINISTRATIVE,
  PRESCREENER_CATEGORIES.BILLING_PAYMENT,
  PRESCREENER_CATEGORIES.CLIENT_PREFERENCES,
];

export function buildContactWizardSteps({
  isEnabled = false,
  showWhoReceivingCareSection = false,
  visibleCategories = [],
} = {}) {
  if (!isEnabled) {
    return [];
  }

  const visible = new Set(visibleCategories);
  const steps = [];

  if (showWhoReceivingCareSection) {
    steps.push({
      id: CLIENT_TYPE_STEP_ID,
      category: null,
    });
  }

  steps.push({
    id: PRESCREENER_CATEGORIES.DEMOGRAPHICS,
    category: PRESCREENER_CATEGORIES.DEMOGRAPHICS,
  });

  OPTIONAL_CATEGORY_ORDER.forEach(category => {
    if (visible.has(category)) {
      steps.push({
        id: category,
        category,
      });
    }
  });

  return steps;
}

export function contactWizardHeadingKey(step) {
  if (!step) {
    return null;
  }

  if (step.id === CLIENT_TYPE_STEP_ID) {
    return 'contact.wizard.clientType';
  }

  return PRESCREENER_CATEGORY_KEYS[step.category] ?? null;
}

export function isContactWizardSectionVisible(currentStepId, sectionId) {
  return !currentStepId || currentStepId === sectionId;
}

export function shouldShowWhoReceivingCareSection(practice) {
  return Boolean(
    practice?.get?.('featureContactFormCustomSettings') &&
      (practice.get('clientTypesAllowedToBookAppt') || []).length > 1
  );
}
